import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpClientService {

	constructor(private http: HttpClient) {
	}

	createAuthorizationHeader(token: string, customContentType?: string) {
    if (customContentType) {
      return new HttpHeaders({
        'Content-Type': `${customContentType}`,
        'Authorization': `${token}`
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `${token}`
      });
    }
	}

	get(url: string, token?: string, customContentType?: string): Observable<any> {
		const headers = this.createAuthorizationHeader(token!, customContentType);
		return this.http.get(url, { headers });
	}

	post(url: string, data: any, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.post(url, data, { headers });
	}

	put(url: string, data: any, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.put(url, data, { headers });
	}

	delete(url: string, token: string) {
		const headers = this.createAuthorizationHeader(token);
		return this.http.delete(url, { headers });
	}
  
}
